import { z } from 'zod';
import { requiredString } from '../helpers';
export const Snapsheet_Create_Claim_4_ConfigValidator = z.object({
    connectionId: requiredString('Snapsheet connection is required'),
    claim: z.union([z.record(z.string(), z.unknown()), requiredString('Claim data is required')])
});
//# sourceMappingURL=snapsheet-create-claim-4.js.map